export default {
  searchAgainHere: '22022019-142905-0006',
  refreshList: '31032021-093504-1096'
};
